module.exports = __webpack_public_path__ + "assets/images/project/ndp2020_doodle.gif?v=6f47a4ae";